/* eslint-disable max-len */
/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';
import moment from 'moment-timezone';
import {
  Button,
  Grid,
  Header,
  Icon,
  Label,
  Popup,
  Segment,
} from 'semantic-ui-react';
import { SortableElement, arrayMove } from 'react-sortable-hoc';
import PackagePricingEdit from './PackagePricingEdit';
import { SortableContainer, SortableDragHandle } from '../';
import { flashErrorMessage } from '../../../actions/flash';
import AppForm from '../../../components/AppForm';
import DeleteConfirm from '../../../containers/modals/DeleteConfirm';
import { PROJECT_PACKAGE_PRICING_DEFAULT } from '../../../structs/package_pricing';

const SortableItem = SortableElement(props => (
  <div className={`sortablehoc_item ${props.itemClass ? props.itemClass : ''}`}>
    <Segment raised={props.isEditing()} className={`package ${props.isEditing() ? 'editing' : ''}`}>
      <Grid>
        <Grid.Row className="row_item">
          <Grid.Column mobile={2} tablet={2} computer={1} verticalAlign="middle">
            {
                props.isSortMode ?
                  (
                    <div className="sorting_buttons">
                      <SortableDragHandle {...props} />
                    </div>
                  ) : (
                    <div>
                      <Label basic={props.value.isEnabled} color={props.value.isEnabled ? null : 'red'} circular>{props.value.orderPriority}</Label>
                    </div>
                  )
              }
          </Grid.Column>
          <Grid.Column mobile={10} tablet={11} computer={13} verticalAlign="middle">
            {props.isEditing() ? props.getStatusText() : (
              <span>
                <span className="text_name">{props.value.name}{props.value.description !== '' ? ':' : ''}</span> <span className="text_description">{props.isEditing() ? '' : props.value.description}</span>
              </span>
            )}
          </Grid.Column>
          <Grid.Column mobile={4} tablet={3} computer={2} textAlign="right">
            <Button
              size="tiny"
              compact
              disabled={props.isSortMode || props.isSortingItems || props.isEditingItems()}
              onClick={e => props.handleCopy(e, props.idx)}
              icon
            >
              <Icon name="copy" color="blue" fitted />
            </Button>
            <Button
              size="tiny"
              color="blue"
              compact
              disabled={props.isSortMode || props.isSortingItems || props.isEditingItems()}
              onClick={e => props.handleEdit(e, props.idx)}
            >
              <Icon name="edit" />
              {props.isEditing() ? 'Done' : 'Edit'}
            </Button>
          </Grid.Column>
        </Grid.Row>
        {
            props.isEditing() ?
              <Grid.Row>
                <Grid.Column width={16}>
                  <PackagePricingEdit
                    data={props.value}
                    isVietnam={props.isVietnam}
                    onBulkManageUnits={props.onBulkManageUnits}
                    onBulkUpdateUnits={props.onBulkUpdateUnits}
                    onChange={props.onChange}
                    onDelete={props.onDelete}
                    onDeleteItem={props.onDeleteItem}
                    onEditingItems={props.onEditingItems}
                    onSortItems={props.onSortItems}
                    refForm={props.setRefForm}
                    refValidation={props.setRefValidation}
                  />
                </Grid.Column>
              </Grid.Row>
              : ''
          }
      </Grid>
    </Segment>
  </div>
));


export default class SortablePackagePricing extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    data: PropTypes.oneOfType([PropTypes.array]).isRequired,
    handleBulkManageUnits: PropTypes.func,
    // CPI-977: passed down so the edit form can offer the deposit-rate field; false elsewhere.
    isVietnam: PropTypes.bool,
    handleBulkUpdateUnits: PropTypes.func,
    handleDelete: PropTypes.func,
    handleDeleteItem: PropTypes.func,
    onChangeData: PropTypes.func,
    onEdit: PropTypes.func,
  }
  static getPropsToState = (props) => {
    const data = props.data || [];
    return {
      data,
    };
  }
  constructor(props) {
    super(props);
    const state = SortablePackagePricing.getPropsToState(props);
    this.state = {
      ...state,
      isEditing: [],
      isEditingItems: [],
      isSortMode: false,
      isSortingItems: false,
      showDeleteConfirm: false,
      deleteIDX: null,
      deleteData: Object.assign({}, PROJECT_PACKAGE_PRICING_DEFAULT),
    };
    this.editRef = [];
    this.formRef = {};
  }
  componentWillReceiveProps(nextProps) {
    const state = SortablePackagePricing.getPropsToState(nextProps);
    if (JSON.stringify(this.state.data) === JSON.stringify(state.data)) {
      this.setState({ ...state });
    } else {
      // collapse all editing forms on save
      this.setState({ ...state, isEditing: [], isEditingItems: [] });
    }
  }
  onSortEnd = ({ oldIndex, newIndex }) => {
    const data = this.sortDataByIndex(arrayMove(this.state.data, oldIndex, newIndex));
    this.setState({ data }, () => {
      if (this.props.onChangeData) this.props.onChangeData(data);
    });
  };
  setRefValidation = (ref, idx) => {
    if (ref && ref.props && ref.props.name) {
      if (!this.editRef[idx]) this.editRef[idx] = {};
      this.editRef[idx][ref.props.name] = ref;
    }
  }
  setRefForm = (ref) => {
    this.formRef = ref;
  }
  getStatusText = (idx) => {
    const { data } = this.state;
    const inputDateFormat = 'DD/MM/YYYY, hh:mm A';
    let statusColor = 'green';
    let statusIcon = 'check';
    let statusTitle = 'Active';
    let statusLabel = 'Active';
    if (data[idx]) {
      if (data[idx].isEnabled) {
        if (data[idx].scheduleStartAt && data[idx].scheduleEndAt) {
          if (
            moment(data[idx].scheduleStartAt).unix() < moment().unix() &&
            moment(data[idx].scheduleEndAt).unix() > moment().unix()
            ) {
            statusIcon = 'calendar check';
            statusColor = 'green';
            statusTitle = `Active schedule: ${moment(data[idx].scheduleStartAt).format(inputDateFormat)} - ${moment(data[idx].scheduleEndAt).format(inputDateFormat)}`;
          } else if (moment(data[idx].scheduleStartAt).unix() > moment().unix()) {
            statusIcon = 'calendar check';
            statusColor = 'yellow';
            statusTitle = `Future schedule: ${moment(data[idx].scheduleStartAt).format(inputDateFormat)} - ${moment(data[idx].scheduleEndAt).format(inputDateFormat)}`;
          } else {
            statusIcon = 'calendar times';
            statusColor = 'red';
            statusTitle = 'Schedule ended';
            statusLabel = 'Expired';
          }
        } else if (data[idx].scheduleStartAt) {
          if (moment(data[idx].scheduleStartAt).unix() < moment().unix()) {
            statusIcon = 'calendar check';
            statusColor = 'green';
            statusTitle = `Active schedule: ${moment(data[idx].scheduleStartAt).format(inputDateFormat)} - Not set`;
          } else {
            statusIcon = 'calendar check';
            statusColor = 'yellow';
            statusTitle = `Future schedule: ${moment(data[idx].scheduleStartAt).format(inputDateFormat)} - Not set`;
          }
        } else if (data[idx].scheduleEndAt) {
          if (moment(data[idx].scheduleEndAt).unix() > moment().unix()) {
            statusIcon = 'calendar check';
            statusColor = 'green';
            statusTitle = `Active schedule: Now - ${moment(data[idx].scheduleEndAt).format(inputDateFormat)}`;
          } else {
            statusIcon = 'calendar times';
            statusColor = 'red';
            statusTitle = 'Schedule ended';
            statusLabel = 'Expired';
          }
        }
      } else {
        statusIcon = 'x';
        statusColor = 'red';
        statusTitle = 'Disabled';
        statusLabel = 'Disabled';
      }
    }
    return (
      <Popup
        trigger={
          <Label tag size="tiny" color={statusColor} style={{ cursor: 'help' }}>
            <Icon fitted name={statusIcon} />
            {statusLabel}
          </Label>
        }
        content={statusTitle}
        inverted
        position="bottom center"
        wide="very"
      />
    );
  }
  checkIsEditing = id => this.state.isEditing.includes(id);
  checkIsEditingItems = () => this.state.isEditingItems.length > 0;
  sortDataByIndex = (newData) => {
    const data = newData;
    data.forEach((d, index) => {
      data[index].orderPriority = index + 1;
    });
    return data;
  }
  handleEdit = async (e, idx) => {
    if (e) e.preventDefault();
    const { data, isEditing } = this.state;
    if (this.state.isEditing.includes(idx)) {
      const { store } = this.context;
      const validations = await AppForm.validate(this.editRef[idx], data[idx]);
      const errMessages = validations.filter(v => !v.isValid);
      if (errMessages.length > 0) {
        store.dispatch(flashErrorMessage({ header: 'Please fix form errors', list: errMessages.map(l => l.message) }));
        return;
      }
      this.setState({ isEditing: isEditing.filter(ai => ai !== idx) }, () => {
        if (this.props.onEdit) this.props.onEdit(this.state.isEditing.length > 0, this.state.data);
      });
      return;
    }
    isEditing.push(idx);
    this.setState({ isEditing }, () => {
      if (this.props.onEdit) this.props.onEdit(this.state.isEditing.length > 0, this.state.data);
    });
  }
  handleToggleSort = (e) => {
    e.preventDefault();
    this.setState({ isSortMode: !this.state.isSortMode });
  }
  handleEditingItems = (itemIDs, itemsData, packagePricingIDX) => {
    const { data } = this.state;
    let { isEditingItems } = this.state;
    // TODO: change to packagePricingCalculations
    data[packagePricingIDX].packagePricingItems = itemsData;
    if (itemIDs.length > 0) {
      if (!isEditingItems.includes(packagePricingIDX)) isEditingItems.push(packagePricingIDX);
    } else {
      isEditingItems = isEditingItems.filter(ai => ai !== packagePricingIDX);
    }
    this.setState({ isEditingItems, data });
  }
  handleOnChange = (d, idx) => {
    const { data } = this.state;
    const newData = [];
    data.forEach((item, i) => {
      if (i === idx) {
        newData.push(d);
      } else {
        newData.push(item);
      }
    });
    this.setState({ data: newData }, () => {
      if (this.editRef[idx]) AppForm.validate(this.editRef[idx], newData[idx]);
      if (this.props.onChangeData) this.props.onChangeData(newData);
    });
  }
  handleDelete = (d, idx) => {
    this.setState({
      showDeleteConfirm: true,
      deleteIDX: idx,
      deleteData: d,
    });
  }
  handleCancelDelete = (e) => {
    e.preventDefault();
    this.setState({
      showDeleteConfirm: false,
      deleteIDX: null,
      deleteData: Object.assign({}, PROJECT_PACKAGE_PRICING_DEFAULT),
    });
  }
  handleConfirmDelete = async (e) => {
    e.preventDefault();
    const { deleteData } = this.state;
    if (deleteData.id !== '' && this.props.handleDelete) {
      await this.props.handleDelete(deleteData.id, () => {
        this.confirmDelete();
      });
    } else {
      this.confirmDelete();
    }
  }
  confirmDelete = () => {
    const { data, deleteIDX } = this.state;
    let { isEditingItems } = this.state;
    const newData = [];
    data.forEach((item, i) => {
      if (i !== deleteIDX) {
        newData.push(item);
      }
    });
    isEditingItems = isEditingItems.filter(ai => ai !== deleteIDX);
    this.setState({
      data: this.sortDataByIndex(newData),
      deleteData: Object.assign({}, PROJECT_PACKAGE_PRICING_DEFAULT),
      deleteIDX: null,
      isEditingItems,
      showDeleteConfirm: false,
    }, () => this.handleEdit(null, deleteIDX));
  }
  handleDeleteItem = async (id, itemID, callBack, packagePricingIDX) => {
    const { isEditingItems } = this.state;
    if (itemID !== '' && this.props.handleDeleteItem) {
      await this.props.handleDeleteItem(id, itemID, callBack);
      this.setState({ isEditingItems: isEditingItems.filter(ai => ai !== packagePricingIDX) });
    } else {
      this.setState({ isEditingItems: isEditingItems.filter(ai => ai !== packagePricingIDX) }, () => {
        callBack();
      });
    }
  }
  handleAdd = (e) => {
    e.preventDefault();
    const { isEditing, data } = this.state;
    isEditing.push(data.length);
    const newItem = clone(Object.assign({}, PROJECT_PACKAGE_PRICING_DEFAULT, {
      orderPriority: data.length + 1,
    }));
    data.push(newItem);
    this.setState({ isEditing, data }, () => {
      if (this.props.onEdit) this.props.onEdit(this.state.isEditing.length > 0, this.state.data);
    });
  }
  handleSortItems = (isSortingItems) => {
    this.setState({ isSortingItems: !isSortingItems });
  }
  handleBulkManageUnits = (isAdd, idx) => {
    if (this.props.handleBulkManageUnits) this.props.handleBulkManageUnits(isAdd, idx);
  }
  handleBulkUpdateUnits = (idx) => {
    if (this.props.handleBulkUpdateUnits) this.props.handleBulkUpdateUnits(idx);
  }
  handleCopy = (e, idx) => {
    e.preventDefault();
    const { isEditing, data } = this.state;
    isEditing.push(data.length);
    const newItem = clone(Object.assign({}, data[idx], {
      orderPriority: data.length + 1,
      id: '',
      createdAt: null,
      updatedAt: null,
    }));
    // TODO: change to packagePricingCalculations
    if (newItem.packagePricingItems) {
      const newItems = newItem.packagePricingItems;
      newItem.packagePricingItems.forEach((d, pid) => {
        newItems[pid].id = '';
        newItems[pid].projectPackagePricingID = '';
        newItems[pid].createdAt = null;
        newItems[pid].updatedAt = null;
      });
      newItem.packagePricingItems = newItems;
    }
    data.push(newItem);
    this.setState({ isEditing, data }, () => {
      if (this.props.onEdit) this.props.onEdit(this.state.isEditing.length > 0, this.state.data, true);
    });
  }
  render() {
    const {
      data,
      deleteData,
      isEditing,
      isSortMode,
      isSortingItems,
      showDeleteConfirm,
    } = this.state;
    return (
      <Segment className="project_package_pricing">
        <DeleteConfirm
          content={`Are you sure you want to delete pricing package ${deleteData.orderPriority}?`}
          onClose={this.handleCancelDelete}
          onConfirm={this.handleConfirmDelete}
          open={showDeleteConfirm}
        />
        <Grid>
          <Grid.Row verticalAlign="middle">
            <Grid.Column width={8} textAlign="left">
              <Header as="h3" className="header_title">
                Pricing Package Setup
              </Header>
            </Grid.Column>
            <Grid.Column width={8} textAlign="right">
              <Button disabled={isEditing.length > 0 || data.length < 1} basic={!isSortMode} active={isSortMode} color={isSortMode ? 'blue' : null} compact onClick={this.handleToggleSort}>
                <Icon name={isSortMode ? 'toggle on' : 'toggle off'} color={isSortMode ? null : 'blue'} />
                Sort Package
              </Button>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="row_content">
            <Grid.Column width={16}>
              {data.length > 0 ? (
                <SortableContainer
                  isSortMode={isSortMode}
                  iconColor="blue"
                  helperClass="sorting"
                  data={data}
                  lockAxis="y"
                  lockToContainerEdges
                  onSortEnd={this.onSortEnd}
                  useDragHandle
                  item={props => (
                    <SortableItem
                      {...props}
                      getStatusText={() => this.getStatusText(props.idx)}
                      handleCopy={this.handleCopy}
                      handleEdit={this.handleEdit}
                      isEditing={() => this.checkIsEditing(props.idx)}
                      isVietnam={this.props.isVietnam}
                      isEditingItems={() => this.checkIsEditingItems(props.idx)}
                      isSortingItems={isSortingItems}
                      onBulkManageUnits={this.handleBulkManageUnits}
                      onBulkUpdateUnits={this.handleBulkUpdateUnits}
                      onChange={d => this.handleOnChange(d, props.idx)}
                      onDelete={d => this.handleDelete(d, props.idx)}
                      onDeleteItem={(itemID, callBack) => this.handleDeleteItem(props.value.id || '', itemID, callBack, props.idx)}
                      onEditingItems={
                        (iIDs, iDatas) => this.handleEditingItems(iIDs, iDatas, props.idx)
                      }
                      onSortItems={this.handleSortItems}
                      setRefForm={this.setRefForm}
                      setRefValidation={ref => this.setRefValidation(ref, props.idx)}
                    />
                  )}
                />
              ) : (
                <Segment className="segment_pricing_package_not_found" textAlign="center">No pricing package found</Segment>
              )}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row textAlign="center" className="row_button_add">
            <Grid.Column width={16}>
              <Button
                basic
                disabled={isEditing.length > 0}
                onClick={this.handleAdd}
              >
                <Icon name="add circle" color="green" /> Add pricing package
            </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sortable/SortablePackagePricing/SortablePackagePricing.jsx